import React from 'react';

import type { Days, TimeRange } from '@zoomit/editor';
import type { ArrayElement} from '@zoomit/primitives';
import { digitsEnToFa } from '@zoomit/primitives';

import { daysStr } from '../../constants/shared';

export function getWorkingHours(days: Days[]) {
  try {
    const parsedDays = parseDays(days);
    return completeCloseDays(parsedDays);
  } catch (e) {
    console.error('Failed to parse working hours', e);
    return [];
  }
}

function parseDays(days: Days[]) {
  const res: Record<ArrayElement<typeof daysStr>, string> = {};
  days.forEach(
    ({ dayOfWeek, timeRanges }) => (res[parseDayOfWeekStr(dayOfWeek)] = parseTimeRanges(timeRanges)),
  );
  return res;
}

function parseDayOfWeekStr(dayOfWeek: string) {
  try {
    return daysStr[parseInt(dayOfWeek)];
  } catch {
    return dayOfWeek;
  }
}

function parseTimeRanges(ranges: TimeRange[] | undefined) {
  return (
    ranges
      ?.map((range) =>
        digitsEnToFa(range.openingTime.split(':')[0] + ' تا ' + range.closingTime.split(':')[0]),
      )
      .join(', ') ?? ''
  );
}

function completeCloseDays(parsedDays: Record<string, string>) {
  const ans: [string, string | React.JSX.Element][] = [];

  daysStr.forEach((item) => {
    if (parsedDays[item]) {
      ans.push([item, parsedDays[item]]);
    } else {
      ans.push([
        item,
        <div key={item} className="text-[#f00]">
          تعطیل
        </div>,
      ]);
    }
  });

  return ans;
}
